import { Link } from "react-router-dom";
import { owner } from "../data/content";
import SubscriberForm from "./SubscriberForm";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="border-t border-[#D8D3CC] mt-24"
      style={{ backgroundColor: "var(--surface)" }}
      data-testid="site-footer"
    >
      <div className="container-narrow py-14 grid gap-10 md:grid-cols-3 items-start">
        <div>
          <p className="eyebrow">A quiet trail</p>
          <h3 className="font-serif text-3xl mt-3 text-[#2C2A28]">
            {owner.name}
          </h3>
          <p className="text-[#5C5852] text-sm mt-2 max-w-xs leading-relaxed">
            {owner.tagline}
          </p>
        </div>

        <div>
          <p className="eyebrow">Wander the site</p>
          <ul className="mt-3 space-y-2 text-[#2C2A28]">
            <li>
              <Link to="/" className="hover:text-[#4A6B53]" data-testid="footer-link-about">About</Link>
            </li>
            <li>
              <Link to="/books" className="hover:text-[#4A6B53]" data-testid="footer-link-books">Books</Link>
            </li>
            <li>
              <Link to="/trek-and-travel" className="hover:text-[#4A6B53]" data-testid="footer-link-trek">Trek & Travel</Link>
            </li>
            <li>
              <Link to="/music" className="hover:text-[#4A6B53]" data-testid="footer-link-music">Music Corner</Link>
            </li>
            <li>
              <Link to="/ai-media" className="hover:text-[#4A6B53]" data-testid="footer-link-ai-media">AI Media</Link>
            </li>
            <li>
              <Link to="/blogs" className="hover:text-[#4A6B53]" data-testid="footer-link-blogs">Blogs</Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-[#4A6B53]" data-testid="footer-link-contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="eyebrow">A small note</p>
          <p className="mt-3 text-[#5C5852] text-sm leading-relaxed max-w-sm">
            This site is hand-tended. Books are still being read, songs are still
            being learned, and trails are still being walked. Come back any time —
            the kettle is always on.
          </p>

          <p className="eyebrow mt-7">Wander together</p>
          <p className="mt-2 text-[#5C5852] text-sm">
            Subscribe for new blogs and treks — sparingly sent.
          </p>
          <SubscriberForm variant="footer" />
        </div>
      </div>

      <div className="border-t border-[#D8D3CC]">
        <div className="container-narrow py-5 flex flex-col sm:flex-row gap-2 sm:justify-between text-xs text-[#5C5852]">
          <span>© {year} {owner.name}. All quiet, all welcome.</span>
          <span>Built slowly, on purpose.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
